import React from "react";
import { ShieldCheck, ShieldAlert } from "lucide-react";
import { Badge } from "./ui/badge";
import { Card, CardContent } from "./ui/card";

/**
 * Renders EVM RWA signal UI based on the evm_signals block in scan responses.
 * Only renders when evm_signals is present (EVM chains only).
 */
export function RwaSignals({ evmSignals }) {
  if (!evmSignals) return null;

  const { is_official_rwa, rwa_impersonation } = evmSignals;

  return (
    <>
      {/* Official RWA badge — reassuring, shown inline near token header */}
      {is_official_rwa && (
        <div
          className="flex items-center gap-2 px-3 py-2 rounded-md border border-[hsl(var(--success)/0.4)] bg-[hsl(var(--success)/0.06)] text-sm"
          data-testid="rwa-official-badge"
        >
          <ShieldCheck size={15} className="text-[hsl(var(--success))] shrink-0" />
          <span className="font-medium text-[hsl(var(--success))]">Official RWA</span>
          <span className="text-[hsl(var(--muted))] text-xs">— tokenized stock issued by Robinhood</span>
          <Badge variant="success" className="ml-auto">Verified</Badge>
        </div>
      )}

      {/* RWA impersonation warning — high-priority, shown above check cards */}
      {rwa_impersonation && (
        <Card
          className="border-[hsl(var(--danger)/0.6)] bg-[hsl(var(--danger)/0.08)]"
          data-testid="rwa-impersonation-banner"
        >
          <CardContent className="py-4">
            <div className="flex items-start gap-3">
              <ShieldAlert
                size={20}
                className="text-[hsl(var(--danger))] shrink-0 mt-0.5"
              />
              <div>
                <div className="font-semibold text-[hsl(var(--danger))] text-sm">
                  ⚠ RWA Impersonation Detected
                </div>
                <p className="mt-1 text-xs text-[hsl(var(--muted))] leading-relaxed">
                  This token's ticker matches a Robinhood tokenized stock but is{" "}
                  <strong className="text-[hsl(var(--fg))]">NOT</strong> the official
                  asset. This is the #1 scam vector on Robinhood Chain — do not buy
                  or interact with this token.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      )}
    </>
  );
}
